export default __webpack_public_path__ + "static/media/img-0542-slovakia-half-face.fd1e170c.png";